module.exports = __webpack_public_path__ + "img/empty-subscription.58556bfc.png";